module.exports = {"categoriesToHide":[{"slug":"non-classe"},{"slug":"actu-44"},{"slug":"actu-49"},{"slug":"actu-5372"},{"slug":"actu-85"}]}


//////////////////
// WEBPACK FOOTER
// ./configjson/categories.json
// module id = 92
// module chunks = 0 1 2 3